import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfua-project-language-dropdown-wrapper _bgc--light _pa-2 _mb-3 _flex"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_option_field = _resolveComponent("option-field")

  return ($options.hasAvailableLanguages)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_component_option_field, {
          key: $options.selectedLanguage,
          "model-value": $options.selectedLanguage,
          class: "_mt-0 _flex-basis-20 gfua-project-language-dropdown-wrapper__options",
          disabled: $options.isDisabled,
          options: $options.availableLanguagesOptions,
          onChange: $options.onChange,
          "data-qa": "project-language-dropdown"
        }, null, 8 /* PROPS */, ["model-value", "disabled", "options", "onChange"]))
      ]))
    : _createCommentVNode("v-if", true)
}